/// User Profile Abbreviation
/// Max. 6 Characters
export const GA_FLEET_ADMIN = "adm";
export const GA_DRIVER_PERFIL = "driver";
export const GA_CAR_WORKSHOP = "workshop";
export const GA_BACKOFFICE_OPERATION = "bk_op";
export const GA_BACKOFFICE_ADMINISTRATOR = "bk_adm";
export const GA_BACKOFFICE_APPROVER_MANAGER = "bk_ap";
export const GA_BACKOFFICE_EXTERNAL = "bk_ex";

/// Screen Name
/// Max. 21 Characters
export const GA_DASHBOARD = "home";
export const GA_SERVICE_REQUEST = "maint_req";
export const GA_SERVICE_REQUEST_CREATION = "maint_req_start";
export const GA_SERVICE_REQUEST_DETAILS = "maint_details";
export const GA_SERVICE_REQUEST_BUDGET = "maint_req_budget";
export const GA_SERVICE_REQUEST_RESCHEDULE = "maint_req_reschedule";
export const GA_SERVICE_REQUEST_CANCEL = "maint_req_cancel";
export const GA_INVOICES = "invoices";
export const GA_INVOICES_DETAILS = "invoices_details";
export const GA_REPORTS = "req_rpts";
export const GA_SUPPORT = "support";
export const GA_SUPPORT_WHATSAPP = "support_whatsapp";
export const GA_UPDATE_MILEAGE = "mileage_updt";
export const GA_REPORT_SERVICE_REQUEST = "rpts_maint_req";
export const GA_REPORT_FLEET_MANAGER = "rpts_fleet_mng";
export const GA_REPORT_CAR_WORKSHOP = "rpts_carwsh";
export const GA_REPORT_SERVICE_REQUEST_HISTORY = "rpts_maint_req_htr";
export const GA_REPORT_LIST_SERVICE_REQUEST = "rpts_maint_req_list";
export const GA_REPORT_SCHEDULE = "rpts_schedules";
export const GA_REPORT_BUDGET_APPROVAL = "rpts_bgt_appr";
export const GA_REPORT_APPROVALS = "rpts_approvals";
export const GA_REPORT_FINALIZATION = "rpts_fnlzt";
export const GA_REPORT_PART_SERVICE_DETAIL = "rpts_prt_srvc_dtls";
export const GA_REPORT_ABSENCE = "rpts_absence";
export const GA_REPORT_APPROVED_INVOICES_BOT = "rpts_approved_invoices_bot";
export const GA_REPORT_SLA = "rpts_sla";
export const GA_FLEET = "fleet";
export const GA_REPORT_CARWORKSHOP_SEARCH_NO_RESULT =
  "rpts_carworkshop_search_no_result";

/// Action
/// Max. 5 Characters
export const GA_BUTTON_CLICK = "btn";

/// Context
/// Max. 5 Characters
export const GA_CREATION = "add";
export const GA_SAVE = "save";
export const GA_EDIT = "edit";
export const GA_REMOVE = "del";
export const GA_BACK = "back";
export const GA_SEND = "send";
export const GA_APPROVAL = "approv";
export const GA_DISAPPROVE = "disapp";
export const GA_DONT_NEGOTIATE = "dntneg";
export const GA_CANCEL = "cancel";
